// extracted by mini-css-extract-plugin
export default {"root":"Form_root__PqvaS"};